import classNames from 'classnames';
import React, { memo } from 'react';
import { MainNavLink } from '../MainNav.interface';
import MainNavDropdown from '../MainNavDropdown/MainNavDropdown';
import CustomLink from '../../../CustomLink/CustomLink';

const MainNavItem: React.FC<MainNavLink> = ({ label, link, dropdown }) => {
  return (
    <li className="h-full flex items-center cursor-pointer group">
      {link && (
        <CustomLink
          url={link?.cached_url}
          label={label}
          className={classNames(
            'nav-link w-full h-full whitespace-nowrap flex justify-center items-center py-1 px-2 text-text/body group-hover:text-text/body-accent'
          )}
        >
          <span>{label}</span>
          {!!dropdown.length && (
            <span
              className="h-[24px] w-[24px] bg-no-repeat group-hover:rotate-180 bg-text/body group-hover:bg-text/body-accent transition-all ease-in-out"
              style={{
                WebkitMaskImage: "url('/svgs/chevron.svg')",
                maskImage: "url('/svgs/chevron.svg')",
              }}
            />
          )}
        </CustomLink>
      )}
      {!!dropdown.length && <MainNavDropdown dropdown={dropdown} />}
    </li>
  );
};

export default memo(MainNavItem);
